import { css, cx } from "@emotion/css";
import { SkeletonHeaders } from "../SkeletonHeaders";
import { ErrorPanel, type ErrorInfo } from "./ErrorPanel";
interface Level1PageLoadingProps {
    errors?: ErrorInfo[];
    isFullWidth?: boolean;
}
export function Level1PageLoading({ errors, isFullWidth }: Level1PageLoadingProps) {
    if (errors && errors.length > 0) {
        return (<>
                {errors?.map((error, index) => (<ErrorPanel key={index} error={error}/>))}
            </>);
    }
    return (<div className={cx(containerStyles, { [containerMaxWidthStyles]: !isFullWidth })}>
            <SkeletonHeaders />
        </div>);
}
const containerStyles = css({
    display: "flex",
    position: "relative",
    flexDirection: "column",
    marginLeft: "auto",
    marginRight: "auto",
});
const containerMaxWidthStyles = css({
    maxWidth: 1280,
});
